import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PrivacyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
  line-height: 1.6;
  color: var(--text-primary);
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--text-primary);
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--text-primary);
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  color: var(--text-secondary);
`;

const LastUpdated = styled.p`
  font-style: italic;
  color: var(--text-light);
  margin-bottom: 2rem;
`;

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true });

  return (
    <PrivacyContainer>
      <Title>{t('privacy.title')}</Title>
      <LastUpdated>{t('privacy.lastUpdated')}</LastUpdated>

      {sections.map((section) => (
        <Section key={section.title}>
          <SectionTitle>{section.title}</SectionTitle>
          {section.paragraphs.map((paragraph) => <Paragraph key={paragraph}>{paragraph}</Paragraph>)}
          {section.items && (
            <Paragraph>
              {section.items.map((item, index) => (
                <React.Fragment key={item}>
                  • {item}{index < section.items.length - 1 && <br />}
                </React.Fragment>
              ))}
            </Paragraph>
          )}
        </Section>
      ))}
    </PrivacyContainer>
  );
};

export default PrivacyPolicyPage;

